import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './infoModal.module.scss';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export type InfoModalProps = {
  className?: string;
  onClose: () => void;
};

export const InfoModal: React.FC<React.PropsWithChildren<InfoModalProps>> = ({
  className,
  children,
  onClose
}) => {
  return (
    <div className={cx(styles.infoModal, className)}>
      <div className={styles.closeBtn}>
        <FontAwesomeIcon icon={faTimes} onClick={onClose} />
      </div>
      {children}
    </div>
  );
};
